import { render, staticRenderFns } from "./DeleteDialog.vue?vue&type=template&id=7f4c0184&"
import script from "./DeleteDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f4c0184')) {
      api.createRecord('7f4c0184', component.options)
    } else {
      api.reload('7f4c0184', component.options)
    }
    module.hot.accept("./DeleteDialog.vue?vue&type=template&id=7f4c0184&", function () {
      api.rerender('7f4c0184', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/core/Components/Common/Modals/DeleteDialog.vue"
export default component.exports